import moment from "moment";

const getBackgroundColor = (d) => {
  console.log("back", d);
  if (d === "Leave Approved") {
    return "#66ff33";
  } else if (d === "Leave Applied" || d === "Leave Rejected") {
    return "#ff9900";
  } else if (d === "Absent") {
    return "#ff0000";
  } else if (d === "Present") {
    return "#33cc33";
  } else if (
    d === "Training" ||
    d === "Meeting" ||
    d === "Office" ||
    d === "Break"
  ) {
    return "#3399ff";
  } else if (d === "Late Check In - Early Check Out") {
    return "#ff0000";
  } else if (
    d === "Late Check In - Late Check Out" ||
    d === "Early Check Out" ||
    d === "Late Check In"
  ) {
    return "#ff5c33";
  } else {
    return "#FFFFFF";
  }
};

/**
 * @description convert dd/mm/yyyy formate date
 * @param {*} date takes standard date formate like 2023-08-31T10:53:55.366+00:00
 * @returns return dd/mm/yyyy formate like 03/09/2023
 */
export const formateData = (date) => {
  const inputDate = new Date(date);
  const formattedDate = `${inputDate.getDate().toString().padStart(2, "0")}/${(
    inputDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${inputDate.getFullYear()}`;
  return formattedDate;
};
export const formatedDate = (date) => {
  return moment(date).format("Do MMM YY");
};
export const transmissionData = (arrayOfUsers, startDate, endDate) => {
  const HEADER_ROW = [
    {
      value: "SAP_ID",
      fontWeight: "bold",
    },
    {
      value: "Territory Name",
      fontWeight: "bold",
    },
    {
      value: "Gross Working Days (excl Sundays | Sat Half Days)",
      fontWeight: "bold",
    },
    {
      value: "No. of Holidays & Leaves",
      fontWeight: "bold",
    },
    {
      value: "No. of Days in Office (Office + Meeting + Training)",
      fontWeight: "bold",
    },
    {
      value: "Total Field Days",
      fontWeight: "bold",
    },
    {
      value: "Total Call",
      fontWeight: "bold",
    },
    {
      value: "Avg calls/Day",
      fontWeight: "bold",
    },
    {
      value: "No of days - Day start b/w 9.30-10",
      fontWeight: "bold",
    },
    {
      value: "Avg time spent/call",
      fontWeight: "bold",
    },
    {
      value: "Planned Vs Unplanned Calls",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to active Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Inactive Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Prospects Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Influencer Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Customers",
      fontWeight: "bold",
    },
  ];
  let formateData = (arrayOfUsers) => {
    let finalData = [];
    arrayOfUsers.forEach((user) => {
      const newArr = [];
      for (const prop in user) {
        if (user.hasOwnProperty(prop) && typeof user[prop] !== "object") {
          newArr.push({ value: user[prop] });
        }
      }
      finalData.push(newArr);
    });
  };
  let newArr = formateData(arrayOfUsers);

  // Format the dates as dd-mm-yyyy
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Append start date and end date to the HEADER_ROW array
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  for (
    let date = new Date(startDate);
    date <= new Date(endDate);
    date.setDate(date.getDate() + 1)
  ) {
    HEADER_ROW.push({
      value: formatDate(date.toISOString()),
      fontWeight: "bold",
    });
  }
  function transformUsersData(arrayOfUsers) {
    let finalArr = [];

    for (let i = 0; i < arrayOfUsers.length; i++) {
      let newUserObj = [];
      for (let prop in arrayOfUsers[i]) {
        if (typeof arrayOfUsers[i][prop] === "number") {
          let backgroundColor;
          if (arrayOfUsers[i][prop] < 3) {
            backgroundColor = "#FF7070";
          } else if (arrayOfUsers[i][prop] < 6) {
            backgroundColor = "#F7E12E";
          } else {
            backgroundColor = "#6FF72E";
          }
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            backgroundColor,
            [prop]: arrayOfUsers[i][prop],
          });
        } else {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
      }
      finalArr.push(newUserObj);
    }

    return finalArr;
  }

  const transformedData = transformUsersData(arrayOfUsers);
  console.log("transformedData", transformedData);

  const data = [HEADER_ROW];
  transformedData.forEach((item) => {
    data.push(item);
  });
  return data;
};


export const transmissionDataRO = (arrayOfUsers, startDate, endDate) => {
  const HEADER_ROW = [
    {
      value: "SAP_ID",
      fontWeight: "bold",
    },
    {
      value: "Region Name",
      fontWeight: "bold",
    },
    {
      value: "Gross Working Days (excl Sundays | Sat Half Days)",
      fontWeight: "bold",
    },
    {
      value: "No. of Holidays & Leaves",
      fontWeight: "bold",
    },
    {
      value: "No. of Days in Office (Office + Meeting + Training)",
      fontWeight: "bold",
    },
    {
      value: "Total Field Days",
      fontWeight: "bold",
    },
    {
      value: "Total Call",
      fontWeight: "bold",
    },
    {
      value: "Avg calls/Day",
      fontWeight: "bold",
    },
    {
      value: "No of days - Day start b/w 9.30-10",
      fontWeight: "bold",
    },
    {
      value: "Avg time spent/call",
      fontWeight: "bold",
    },
    {
      value: "Planned Vs Unplanned Calls",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to active Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Inactive Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Prospects Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Influencer Dealers",
      fontWeight: "bold",
    },
    {
      value: "Total Calls / % calls to Customers",
      fontWeight: "bold",
    },
  ];
  let formateData = (arrayOfUsers) => {
    let finalData = [];
    arrayOfUsers.forEach((user) => {
      const newArr = [];
      for (const prop in user) {
        if (user.hasOwnProperty(prop) && typeof user[prop] !== "object") {
          newArr.push({ value: user[prop] });
        }
      }
      finalData.push(newArr);
    });
  };
  let newArr = formateData(arrayOfUsers);

  // Format the dates as dd-mm-yyyy
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Append start date and end date to the HEADER_ROW array
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  for (
    let date = new Date(startDate);
    date <= new Date(endDate);
    date.setDate(date.getDate() + 1)
  ) {
    HEADER_ROW.push({
      value: formatDate(date.toISOString()),
      fontWeight: "bold",
    });
  }
  function transformUsersData(arrayOfUsers) {
    let finalArr = [];

    for (let i = 0; i < arrayOfUsers.length; i++) {
      let newUserObj = [];
      for (let prop in arrayOfUsers[i]) {
        if (typeof arrayOfUsers[i][prop] === "number") {
          let backgroundColor;
          if (arrayOfUsers[i][prop] < 3) {
            backgroundColor = "#FF7070";
          } else if (arrayOfUsers[i][prop] < 6) {
            backgroundColor = "#F7E12E";
          } else {
            backgroundColor = "#6FF72E";
          }
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            backgroundColor,
            [prop]: arrayOfUsers[i][prop],
          });
        } else {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
      }
      finalArr.push(newUserObj);
    }

    return finalArr;
  }

  const transformedData = transformUsersData(arrayOfUsers);
  console.log("transformedData", transformedData);

  const data = [HEADER_ROW];
  transformedData.forEach((item) => {
    data.push(item);
  });
  return data;
};
export const attendanceDataExcel = (arrayOfUsers, startDate, endDate) => {
  const HEADER_ROW = [
    {
      value: "SAP_ID",
      fontWeight: "bold",
    },
    {
      value: "Territory",
      fontWeight: "bold",
    },
    {
      value: "Area",
      fontWeight: "bold",
    },
    {
      value: "Region",
      fontWeight: "bold",
    },
    {
      value: "Zone",
      fontWeight: "bold",
    },
  ];

  const HEADER_ROW1 = [null, null, null, null, null];

  let formateData = (arrayOfUsers) => {
    let finalData = [];
    arrayOfUsers.forEach((user) => {
      const newArr = [];
      for (const prop in user) {
        if (user.hasOwnProperty(prop) && typeof user[prop] !== "object") {
          newArr.push({ value: user[prop] });
        }
      }
      finalData.push(newArr);
    });
  };
  let newArr = formateData(arrayOfUsers);

  // Format the dates as dd-mm-yyyy
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Append start date and end date to the HEADER_ROW array
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  for (
    let date = new Date(startDate);
    date <= new Date(endDate);
    date.setDate(date.getDate() + 1)
  ) {
    HEADER_ROW.push({
      value: formatDate(date.toISOString()),
      fontWeight: "bold",
      span: 3,
    });
    HEADER_ROW.push(null);
    HEADER_ROW.push(null);

    HEADER_ROW1.push({
      value: "Check In Time",
      fontWeight: "bold",
    });
    HEADER_ROW1.push({
      value: "Check Out Time",
      fontWeight: "bold",
    });
    HEADER_ROW1.push({
      value: "Status",
      fontWeight: "bold",
    });
  }
  function transformUsersData(arrayOfUsers) {
    let finalArr = [];
    console.log("prop1", arrayOfUsers);
    let dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;

    for (let i = 0; i < arrayOfUsers.length; i++) {
      let newUserObj = [];
      for (let prop in arrayOfUsers[i]) {
        if (prop === "SAP_ID") {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
        if (prop === "Territory") {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
        if (prop === "Area") {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
        if (prop === "Region") {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
        if (prop === "Zone") {
          newUserObj.push({
            value: arrayOfUsers[i][prop],
            [prop]: arrayOfUsers[i][prop],
          });
        }
        if (dateFormatRegex.test(prop)) {
          newUserObj.push({
            value: arrayOfUsers[i][prop].checkIn,
            [prop]: arrayOfUsers[i][prop].checkIn,
          });
          newUserObj.push({
            value: arrayOfUsers[i][prop].checkOut,
            [prop]: arrayOfUsers[i][prop].checkOut,
          });
          newUserObj.push({
            value: arrayOfUsers[i][prop].status,
            [prop]: arrayOfUsers[i][prop].status,
            backgroundColor: getBackgroundColor(arrayOfUsers[i][prop].status),
          });
        }
      }
      finalArr.push(newUserObj);
    }

    return finalArr;
  }

  const transformedData = transformUsersData(arrayOfUsers);
  console.log("transformedData", transformedData);

  const data = [HEADER_ROW, HEADER_ROW1];
  transformedData.forEach((item) => {
    data.push(item);
  });
  return data;
};
